import { SEARCH_KEYS } from '../../../constants/query-params/search';
import { MULTIPLE_SELECTION_FILTERS } from '../../../constants/search';
import { world } from '../../../languages';

const compareFilterValues = (a: string, b: string): number => {
    const numericA = Number(a);
    const numericB = Number(b);

    if (Number.isFinite(numericA) && Number.isFinite(numericB)) {
        return numericA - numericB;
    }

    return a.localeCompare(b);
};

const normalizeSearchForKey = (search: SearchState): SearchState => {
    const normalized = { ...search };

    MULTIPLE_SELECTION_FILTERS.forEach((key) => {
        const value = normalized[key as keyof typeof normalized];

        if (Array.isArray(value)) {
            (normalized as Record<string, unknown>)[key] = value.map((id) => `${id}`).sort(compareFilterValues);
        }
    });

    const taxonomy = normalized[SEARCH_KEYS.TAXONOMY as keyof typeof normalized];

    (normalized as Record<string, unknown>)[SEARCH_KEYS.TAXONOMY] =
        taxonomy === null || typeof taxonomy === 'undefined' ? null : `${taxonomy}`;

    const priceRange = normalized[SEARCH_KEYS.PRICE as keyof typeof normalized];
    const isCustomRangeActive = Array.isArray(priceRange)
        ? priceRange.includes(SEARCH_KEYS.PRICE_RANGE)
        : priceRange === SEARCH_KEYS.PRICE_RANGE;

    if (!isCustomRangeActive) {
        (normalized as Record<string, unknown>)[SEARCH_KEYS.PRICE_FROM] = undefined;
        (normalized as Record<string, unknown>)[SEARCH_KEYS.PRICE_TO] = undefined;
    }

    return normalized;
};

export const baseSearchKeys = {
    all: ['base-search'] as const,
    results: (context: string, search: SearchState) =>
        [...baseSearchKeys.all, 'results', context, world, normalizeSearchForKey(search)] as const
} as const;
